import { contentFragments } from 'app/queries/content/all-content-list'
import { Banner, bannerFragment } from './banner'
import { ExternalImage, externalImageFragment } from './external-image'
import { FAQs, faqsFragment } from './faqs'
import { TrendingSeries, trendingSeriesFragment } from './trending-series'
import { ComingUp, comingUpFragment } from './homepage/coming-up'
import {
  ContinueWatching,
  continueWatchingFragment,
} from './homepage/continue-watching'
import {
  HomepageFeatured,
  homepageFeaturedFragment,
} from './homepage/homepage-featured'
import { Latest, latestFragment } from './homepage/latest'
import { NextUp, nextUpFragment } from './homepage/next-up'
import { Popular, popularFragment } from './homepage/popular'
import { Recommended, recommendedFragment } from './homepage/recommended'
import {
  SeriesYouMightLike,
  seriesYouMightLikeFragment,
} from './series-you-might-like'
import { Image, imageFragment } from './image'
import { PromoCode, promoCodeFragment } from './promo-code'
import { RichText, richTextFragment } from './rich-text'
import { SpotifyEmbed, spotifyEmbedFragment } from './spotify-embed'
import { Video, videoFragment } from './video'
import { PromoBanner, promoBanner } from './promo-banner'
import { ImageCarousel, imageCarouselFragment } from './image-carousel'
import { CallToAction, callToActionFragment } from './call-to-action'
import { ProductGrid, productGridFragment } from './product-grid'
import { Form, formFragment } from 'app/blocks/form'
import { LandingHero, landingHeroFragment } from './landing/landing-hero'
import { RainbowHero, rainbowHeroFragment } from './landing/rainbow-hero'
import {
  BenefitsBanner,
  benefitsBannerFragment,
} from './landing/benefits-banner'
import {
  LandingMemberQuote,
  landingMemberQuoteFragment,
} from './landing/landing-member-quote'
import {
  ScrollingCarousel,
  scrollingCarouselFragment,
} from './landing/scrolling-carousel'
import {
  ScrollingContentCarousel,
  scrollingContentCarouselFragment,
} from './landing/scrolling-content-carousel'
import { LandingPerks, landingPerksFragment } from './landing/landing-perks'
import {
  LandingCollectibles,
  landingCollectiblesFragment,
} from './landing/landing-collectibles'
import {
  RedeemCollectable,
  redeemCollectableFragment,
} from './redeem-collectable'
import { Button, buttonFragment } from './button'
import {
  HomepageContentCarousel,
  homepageContentCarouselFragment,
} from './homepage/homepage-content-carousel'
import { GifOfTheDay, gifOfTheDayFragment } from './homepage/gif-of-the-day'
import {
  JustUpdatedSeries,
  justUpdatedSeriesFragment,
} from './just-updated-series'
import {
  CollectibleProgress,
  collectibleProgressFragment,
} from './collectible-progress'
import {
  MerchCollectiblesCallToAction,
  merchCollectiblesCallToActionFragment,
} from './merch-collectibles-call-to-action'
import { LatestGrid, latestGridFragment } from './latest-grid'

export const postContentBlocks = `
  ${richTextFragment}
  ${videoFragment}
  ${imageFragment}
  ${externalImageFragment}
  ${spotifyEmbedFragment}
  ${promoCodeFragment}
  ${imageCarouselFragment}
  ${productGridFragment}
  ${formFragment}
`

export type PostContentBlock =
  | RichText
  | Video
  | Image
  | ExternalImage
  | SpotifyEmbed
  | PromoCode
  | ImageCarousel
  | ProductGrid
  | Form

export const pageContentBlocks = `
  ${richTextFragment}
  ${videoFragment}
  ${imageFragment}
  ${bannerFragment}
  ${externalImageFragment}
  ${faqsFragment}
  ${productGridFragment}
  ${formFragment}
  ${redeemCollectableFragment}
  ${buttonFragment}
  ${collectibleProgressFragment}
`

export type PageContentBlock =
  | RichText
  | Video
  | Image
  | Banner
  | ExternalImage
  | FAQs
  | ProductGrid
  | Form
  | RedeemCollectable
  | Button
  | CollectibleProgress

export const landingContentBlocks = `
  ${contentFragments}
  ${bannerFragment}
  ${faqsFragment}
  ${landingHeroFragment}
  ${promoBanner}
  ${rainbowHeroFragment}
  ${benefitsBannerFragment}
  ${landingMemberQuoteFragment}
  ${scrollingCarouselFragment}
  ${scrollingContentCarouselFragment}
  ${landingPerksFragment}
  ${landingCollectiblesFragment}
`

export type LandingContentBlock =
  | Banner
  | FAQs
  | LandingHero
  | PromoBanner
  | RainbowHero
  | BenefitsBanner
  | LandingMemberQuote
  | ScrollingCarousel
  | ScrollingContentCarousel
  | LandingPerks
  | LandingCollectibles

export type HomepageContentBlock =
  | TrendingSeries
  | Banner
  | ComingUp
  | ContinueWatching
  | HomepageFeatured
  | Latest
  | NextUp
  | Popular
  | Recommended
  | SeriesYouMightLike
  | PromoBanner
  | ProductGrid
  | HomepageContentCarousel
  | GifOfTheDay

export const merchPageContentBlocks = `
  ${bannerFragment}
  ${callToActionFragment}
  ${merchCollectiblesCallToActionFragment}
  ${productGridFragment}
  ${promoCodeFragment}
`

export type MerchPageContentBlock =
  | Banner
  | CallToAction
  | MerchCollectiblesCallToAction
  | ProductGrid
  | PromoCode

export const collectiblePageContentBlocks = `
  ${richTextFragment}
  ${imageFragment}
  ${callToActionFragment}
  ${collectibleProgressFragment}
`

export type AllSeriesContentBlocks =
  | TrendingSeries
  | JustUpdatedSeries
  | Banner
  | PromoBanner
  | LatestGrid

export const allSeriesContentBlocks = `
  ${trendingSeriesFragment}
  ${justUpdatedSeriesFragment}
  ${bannerFragment}
  ${promoBanner}
  ${latestGridFragment}
`

export type CollectiblePageContentBlock =
  | Image
  | RichText
  | CallToAction
  | CollectibleProgress
